// Adaptadores: convierten objetos CMS (Strapi v5) al shape ligero que usan las páginas.
// Mientras el CMS aún no tenga contenido cargado, los componentes pueden caer al
// dataset estático de `src/data/*` sin cambiar su API.

import type {
  ConfiguracionGlobal as CmsConfig,
  Programa as CmsPrograma,
  Sede as CmsSede,
} from "../types/cms";
import type { Program, ProgramAccent } from "../data/programs";
import type { Sede } from "../data/sedes";

export function programaCmsToCard(p: CmsPrograma): Program {
  return {
    slug: p.slug,
    name: p.nombre,
    short: p.eslogan ?? p.descripcionCorta?.split(".")[0] ?? "",
    long: p.descripcionCorta ?? "",
    ages: "", // se rellena en futura iteración con un campo dedicado
    when: "", // ídem
    accent: (p.acentoColor as ProgramAccent) ?? "leaf",
    ctaLabel: "Saber más",
  };
}

export function sedeCmsToCard(s: CmsSede): Sede {
  return {
    city: s.ciudad,
    venue: s.nombreLugar ?? "",
    shortDescription: s.descripcionCorta ?? "",
    imageUrl: s.imagenPortada?.url,
    mapUrl: s.enlaceMapa,
  };
}

export function configCmsToSite(c?: CmsConfig | null) {
  if (!c) return null;
  return {
    name: c.nombreSitio,
    tagline: c.tagline,
    description: c.descripcionCorta,
    email: c.emailContacto,
    social: {
      facebook: { label: c.facebookHandle, url: c.facebookUrl },
      instagram: { label: c.instagramHandle, url: c.instagramUrl },
    },
    moodleUrl: c.moodleUrl,
  };
}
